<template>
  <div class="ss__custom__header__write">
    <SsButton2
      type="text"
      class="ss__custom__header__btn__write"
      @click="onBtnClick">
      <i class="ssCommunityIcon__write"/>
    </SsButton2>
    <!-- 新功能提醒 -->
    <SsFeaturePopover
      class="comp__SsFeaturePopover"
      :visible.sync="featurePopoverVisible"
      title="无需申请，自由写作"
      content="任何用户都可使用写作功能。成功发布 3 篇符合基本规则的内容，可成为正式作者。<a href='https://manual.sspai.com/guides/quickstart/' target='_blank'>了解更多</a>"
      :target="featurePopoverTarget"
    />
  </div>
</template>

<script>
import SsButton2 from '../../../SsButton2'
import SsFeaturePopover from '../../../SsFeaturePopover'
export default {
  name: 'SsCustomHeaderWrite',

  components: {
    SsButton2,
    SsFeaturePopover
  },

  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      featurePopoverVisible: false,
      featurePopoverTarget: '.ss__custom__header__btn__write'
    }
  },

  methods: {
    showFeaturePopover () {
      const feature = window.localStorage.getItem('enabling__writing__feature')
      if (feature) return
      this.featurePopoverVisible = true
      window.localStorage.setItem('enabling__writing__feature', '1')
    },
    onBtnClick () {
      if (!this.isLogin) {
        this.$emit('login')
      } else {
        this.$openLink('/write', '_self')
      }
      dispatchEvent(new CustomEvent('ssCustomHeaderToggleTarget', { detail: 'write' }))
    }
  },

  mounted () {
    setTimeout(this.showFeaturePopover, 400)
  }
}
</script>

<style lang="stylus" scoped>
.ss__custom__header__write {
  .ss__custom__header__btn__write {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--w-ssCustonHeaderBtnWrite, 32px);
    height: var(--h-ssCustonHeaderBtnWrite, 32px);
    i {
      font-size: var(--size-ssCustonHeaderWriteIcon, 20px);
      color: var(--color-ssCustonHeaderWriteIcon, var(--B8-t));
    }
  }
  .comp__SsFeaturePopover {
    >>> a {
      color: var(--blue-t)
    }
  }
}
</style>
